export default "__VITE_ASSET__DgwivJTc__"